export const QRDetails = {
    GET_QRDATADETAILS: "GET_QRDATADETAILS",
    DELETE_SELECTED_QRTYPE: "DELETE_SELECTED_QRTYPE",
    DELETE_MULTIPLE_QRTYPE: "DELETE_MULTIPLE_QRTYPE",
    PUT_UPDATEQREDIT_DETAILS: "PUT_UPDATEQREDIT_DETAILS"
   
}